module.exports = __webpack_public_path__ + "static/img/home_pic3.d6b514d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home2/home_pic3.png
// module id = aEhH
// module chunks = 1